import React, { FunctionComponent } from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { CallHistoryMethodAction, push } from 'connected-react-router';

import { Translate } from 'react-localize-redux';

import styled, { css } from 'styled-components';

// Store
import AppState from '@webapp/store/state';

// Types
import SimpleArtist from '@common/types/artist/simple-artist';

// Components
import NFTRow from '@components/nft-row';
import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';

import EmptySectionBox from '../empty-wrapper';

import { MerchProductColor } from '@services/merch/types/api/merch-product-color';
import { ReleaseStatus } from '@common/types/release/relase-status';

export interface NFTType {
  id: string;
  type: string;
  image: string;
  title: string;
  upc?: string;
  date_added: Date;
  editions: number;
  price: string;
  status: ReleaseStatus;
  owenership: string;
  qty: number;
  stakeholders: number;
  colors?: MerchProductColor[];
}

interface CatalogNFTProps {
  activeArtist: SimpleArtist;
  isMobile: boolean;
  push: (path: string) => CallHistoryMethodAction;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
  activeArtist: state.artist.active as SimpleArtist,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  push: (path: string) => dispatch(push(path)),
});

const HEADER_TITLES = [
  { id: 'releases', label: <Translate id="CATALOG.HEADER.RELEASE" /> },
  { id: 'date-added', label: <Translate id="CATALOG.HEADER.DATE_ADDED" /> },
  { id: 'editions', label: <Translate id="CATALOG.HEADER.EDITIONS" /> },
  { id: 'status', label: <Translate id="CATALOG.HEADER.STATUS" /> },
];

// TODO: DEVTEAM-603 - NFTS_DEMO - THIS IS FOR DEMO ONLY - We need to use real data.
const NFTS_DEMO: NFTType[] = [];

const CatalogNFT: FunctionComponent<CatalogNFTProps> = ({
  activeArtist,
  isMobile,
}) => {
  // TODO: DEVTEAM-603 - const hasNFT = false; needs to be created, Currently we don't have any nfts.
  const hasNFT = false;

  if (!hasNFT) {
    return (
      <EmptySectionBox
        header={<Translate id="CATALOG.NFT.EMPTY.TITLE" />}
        title={<Translate id="CATALOG.NFT.EMPTY.ADD.TITLE" />}
        text={<Translate id="CATALOG.NFT.EMPTY.ADD.TEXT" />}
        // TODO: DEVTEAM-603 - We need to define where are we going to send the user.
        onClick={() => void 0}
      />
    );
  }

  return (
    <div>
      {!isMobile ? (
        <TableTitles>
          {HEADER_TITLES.map((item) => (
            <div className={item.id} key={item.id}>
              <Typography weight="700">{item.label}</Typography>
            </div>
          ))}
        </TableTitles>
      ) : null}
      <CatalogTabWrapper isMobile={isMobile}>
        {NFTS_DEMO.map((item, i) => (
          <NFTRow item={item} artist={activeArtist} key={`#${item.id}#${i}`} />
        ))}
      </CatalogTabWrapper>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogNFT);

const TableTitles = styled(Grid)`
  grid-template-columns: repeat(18, minmax(0, 1fr));
  grid-gap: 30px;
  align-items: center;
  padding: 0 30px 30px;

  .merch {
    grid-column: 1 / 7;
  }
  .date-added {
    grid-column: 7 / 9;
  }
  .price-profit {
    grid-column: 9 / 11;
  }
  .status {
    grid-column: 11 / 17;
  }
  .actions {
    grid-column: 17 / 19;
  }

  @media ${({ theme }) => theme.device.laptop} {
    .merch {
      grid-column: 1 / 9;
    }
    .date-added {
      grid-column: 9 / 11;
    }
    .price-profit {
      grid-column: 11 / 13;
    }
    .status {
      grid-column: 13 / 17;
    }
    .actions {
      grid-column: 17 / 19;
    }
  }
`;

const CatalogTabWrapper = styled.div<{ isMobile: boolean }>`
  display: grid;
  grid-gap: 10px;

  ${(props) =>
    !props.isMobile
      ? css`
          position: relative;
        `
      : ''}
`;
